// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__1-_Hg","container":"styles_container__1cu-g","title":"styles_title__-qOUA","wrapper":"styles_wrapper__3mWjv","answer":"styles_answer__1UgfI"};